"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.footerValidator = footerValidator;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = require("../Button");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function footerValidator(props, propName, componentName) {
  var defaultFooter = props.defaultFooter,
      actions = props.actions;

  if (!!defaultFooter && !!actions) {
    return new Error("Both `defaultFooter` and `actions` are supplied to `".concat(componentName, "`. `defaultFooter` will not be used"));
  }

  if (defaultFooter) {
    _propTypes.default.checkPropTypes(_defineProperty({}, propName, _propTypes.default.bool), props, propName, componentName);
  }

  if (actions) {
    _propTypes.default.checkPropTypes(_defineProperty({}, propName, _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.shape((0, _Button.makeButtonSchemaPropTypes)({
      id: _propTypes.default.string.isRequired
    }))), _propTypes.default.shape({
      left: _propTypes.default.arrayOf(_propTypes.default.shape((0, _Button.makeButtonSchemaPropTypes)({
        id: _propTypes.default.string.isRequired
      }))),
      right: _propTypes.default.arrayOf(_propTypes.default.shape((0, _Button.makeButtonSchemaPropTypes)({
        id: _propTypes.default.string.isRequired
      })))
    })])), props, propName, componentName);
  }

  return null;
} // eslint-disable-next-line import/prefer-default-export